import { Service } from '@angular/core';

@Service()
export class LocalStorageService {
  getJson(key: string): unknown {
    try {
      const raw = localStorage.getItem(key);
      return raw === null ? undefined : JSON.parse(raw);
    } catch {
      return undefined;
    }
  }

  setJson(key: string, value: unknown): boolean {
    try {
      const serialized = JSON.stringify(value);
      if (serialized === undefined) {
        return false;
      }
      localStorage.setItem(key, serialized);
      return true;
    } catch {
      return false;
    }
  }

  remove(key: string): boolean {
    try {
      localStorage.removeItem(key);
      return true;
    } catch {
      return false;
    }
  }
}
